import styled from 'styled-components';
import { InputAdornment as MuiInputAdornment } from '@material-ui/core';

export const TableWrapper = styled.div`
  padding: 32px;

  & .rdt_TableRow{
    height: 68px;
    cursor: pointer;
  }

  & .rdt_TableCell{
    color: var(--grayLv4);
    font-size: 1.4rem;
  }

  & .rdt_TableCol{
    font-size: 1.4rem;
    /* font-family: OpenSans-SemiBold; */
    color: var(--grayLv4);
  }

  & .rdt_TableCol_Sortable {
    span {
      font-size: 12px;
    }
  }

  & .rdt_Pagination {
    & > span, div {
      font-size: 1.2rem;
      margin-top: 24px;
      color: var(--grayLv4);
    }
    & svg {
      color: var(--grayLv4);
    }
  }

  & .drfNcF {
    margin: 64px 0;
    color: var(--grayLv4);
    font-size: 1.4rem;
  }

  & .hDslYW {
    color: var(--grayLv4);
    margin: 32px 0;
  }

  
  @media(min-width:1920px) {
    padding: 38px;

    & .rdt_TableCell{
      font-size: 1.6rem;
    }

    & .rdt_TableCol{
      font-size: 1.6rem;
    }
  }
`;

export const InputAdornment = styled(MuiInputAdornment)`
  &:hover {
    cursor: pointer;
    box-shadow: 2px 2px 5px darkgray;
  }
`;